import { DepartmentResource, DepartmentViewModel, GroupResource } from '@/models'
import { transformGroupResource } from '@/services/GroupService/transformGroupResource'

export function transformDepartmentResource(
    department: DepartmentResource,
    group?: GroupResource,
): DepartmentViewModel {
    return {
        id: department.id,
        name: department.name,
        group: group ? transformGroupResource(group) : undefined,
    }
}
